export const hideGoogleOneTap = (): void => {
  window?.google?.accounts?.id?.cancel?.();
};
